// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"902f4e460dc174a1284c6f8ce14b7749c93195a1"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";globalThis["_sentryAssetPrefix"] = undefined;globalThis["_sentryExperimentalThirdPartyOriginStackFrames"] = undefined;import * as Sentry from '@sentry/nextjs';

Sentry.init({
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  environment: process.env.NEXT_PUBLIC_SENTRY_ENV,

  // Adjust this value in production, or use tracesSampler for greater control
  tracesSampleRate: 0.02,

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false,

  replaysOnErrorSampleRate: 0.001, // TODO: 求人詳細のハイドレーションエラーを修正したら1に戻す

  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  replaysSessionSampleRate: 0,

  // You can remove this option if you're not planning to use the Sentry Session Replay feature:
  integrations: [
    Sentry.browserTracingIntegration({ enableInp: true }),
    Sentry.replayIntegration({ maskAllText: true, blockAllMedia: true }),
    Sentry.thirdPartyErrorFilterIntegration({
      filterKeys: ['yuffie'],
      behaviour: 'drop-error-if-contains-third-party-frames',
    }),
  ],

  ignoreErrors: [
    'Abort route change. Please ignore this error.',
    'AbortError: Aborted',
    'AbortError: The operation was aborted.',
    'AbortError: The user aborted a request.',
    'AxiosError: Network Error',
    "Can't find variable: gmo",
    "Can't find variable: instantSearchSDKJSBridgeClearHighlight",
    'Error: Cancel rendering route',
    'Invariant: attempted to hard navigate to the same URL',
    'No error message',
    'Non-Error exception captured',
    'Non-Error promise rejection captured',
    'ResizeObserver loop limit exceeded',
    'ResizeObserver loop completed with undelivered notifications.',
    "The requested resource isn't a valid image for",
    'TypeError: Failed to fetch',
    'TypeError: Load failed',
    'TypeError: Network request failed',
    'TypeError: NetworkError when attempting to fetch resource.',
    'Unexpected end of input',
    'Unexpected end of JSON input',
    'Failed to initialize NumberFormat since used feature is not supported in the linked ICU version',
  ],

  allowUrls: [/findy-code\.io/i],
});
